module.exports = __webpack_public_path__ + "img/BCA.173ae5db.png";